module.exports = __webpack_public_path__ + "static/media/hot-pool-color.4404bfac.svg";